"use client"

import type { LucideIcon } from "lucide-react"

interface DashboardStatCardProps {
  icon: LucideIcon
  label: string
  value: string
  iconBgColor: string
  iconColor: string
}

export function DashboardStatCard({ icon: Icon, label, value, iconBgColor, iconColor }: DashboardStatCardProps) {
  return (
    <div className="bg-white border border-slate-100 shadow-sm rounded-2xl px-3 py-2.5 flex items-center gap-2.5">
      <div className={`${iconBgColor} p-2 rounded-xl shrink-0`}>
        <Icon className={`${iconColor} w-4 h-4`} />
      </div>
      <div className="min-w-0">
        <p className="text-[10px] font-semibold text-slate-400 uppercase tracking-wide leading-none mb-0.5">{label}</p>
        <p className="text-sm font-black text-slate-900 leading-none truncate">{value}</p>
      </div>
    </div>
  )
}
